/* eslint-disable */
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Container from 'components/Container';
import { useHistory, useLocation } from 'react-router';

const RenderWrapper = ({
  isInitInProgress,
  isInitialized,
  initialize,
  user,
  component,
  renderProps,
  product,
  initializedProduct
}) => {
  const history = useHistory();
  const location = useLocation();
  const Render = component;

  const getVariant = () => {
    return {
      variant: 'dark',
      bg: 'turquoise'
    };
  };

  useEffect(() => {
    if (
      (!isInitialized && !isInitInProgress) ||
      (!isInitInProgress && product !== initializedProduct)
    ) {
      initialize(false, product);
    }
  }, []);

  useEffect(() => {
    if (isInitialized && !user.isAuthenticated) {
      const path = {
        pathname:
          product === 'global' ? '/login' : `/${product.replace(/_/g, '-')}/login`,
        state: { from: location.pathname + location.search }
      };

      history.push(path);
    }
  }, [isInitInProgress, isInitialized, initialize, user, component]);

  if (
    isInitialized &&
    !isInitInProgress &&
    user.isAuthenticated &&
    initializedProduct === product
  ) {
    return <Render {...renderProps} />;
  }

  return <Container isLoading variant={getVariant().variant} bg={getVariant().bg} />;
};

RenderWrapper.propTypes = {
  component: PropTypes.any.isRequired,
  user: PropTypes.object.isRequired,
  isInitInProgress: PropTypes.bool,
  isInitialized: PropTypes.bool,
  initialize: PropTypes.func.isRequired
};

export default RenderWrapper;
